<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex align-items-center">
        <h3 class="mb-0">รายการสินค้า</h3>
        <button class="ml-auto btn btn-outline-primary" data-toggle="modal" data-target="#itemModal">เพิ่มสินค้าใหม่</button>
      </div>
      <div class="card-body table-responsive">
        <div class="alert alert-success" v-if="msgSuccess">{{ msgSuccess }}</div>
        <div class="alert alert-danger" v-if="msgError">{{ msgError }}</div>
        <table class="table table-sm w-100 bg-white" id="datatable">
          <thead>
            <tr>
              <th>วันที่สร้าง</th>
              <th>รหัส</th>
              <th>ชื่อ</th>
              <th>หน่วย</th>
              <th>ราคาต่อหน่วย</th>
              <th style="width:80px !important;">Action</th>
            </tr>
          </thead>
          <tbody></tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <ItemComponent
      v-on:update-success="updateSuccessDataTable"
      v-on:update-fail="updateFailDataTable"
    />
  </div>
</template>

<script>
import ItemComponent from "./ItemComponent.vue";
export default {
  components: {
    ItemComponent,
  },
  data() {
    return {
      msgSuccess: "",
      msgError: "",
      dataTable: null
    };
  },
  mounted() {
    let parent = this;
    this.dataTable = $("#datatable").DataTable({
      dom: "tpr",
      pageLength: 50,
      processing: true,
      serverSide: true,
      ajax: "/items/datatable",
      order: [[0, 'DESC']],
      columns: [
        { data: "created_at", name: "created_at" },
        { data: "code", name: "code" },
        { data: "name", name: "name" },
        { data: "unit", name: "unit" },
        { data: "unit_price", name: "unit_price" },
        { data: "action", name: "action", orderable: false, searchable: false }
      ],
      initComplete: function() {
        //setup datatable when all data ready
        this.api()
          .columns([0, 1, 2, 3, 4, 5])
          .every(function(i) {
            let column = this;
            let input = null;

            input = $(document.createElement("input"));
            input
              .addClass("form-control form-control-sm")
              .css("width", "100%")
              .appendTo($(column.footer()).empty())
              .on("change", function() {
                column.search($(this).val(), false, false, true).draw();
              });
          });
        this.find("tfoot tr").appendTo(this.find("thead"));
      }
    });
  },
  methods: {
    reloadDT() {
      this.dataTable.ajax.reload(null, false); //reload dataTable
    },
    updateSuccessDataTable: function() {
      this.dataTable.ajax.reload(null, false); //reload dataTable
      this.msgSuccess = "ปรับปรุงข้อมูลสำเร็จ";
      setTimeout(() => (this.msgSuccess = ""), 2000);
    },
    updateFailDataTable: function() {
      this.msgError = "เกิดข้อผิดผลาดในการบันทึกข้อมูล";
      setTimeout(() => (this.msgError = ""), 2000);
    }
  }
};
</script>